<template>
  <account-reset platform="portal"/>
</template>

<script>
import AccountReset from '../../components/assemble-account/AccountReset.vue';

export default {
  name: 'Reset',
  components: {
    'account-reset': AccountReset
  }
};
</script>

<style scoped lang="scss">
</style>
